import React, { useState, useEffect, useContext } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Box, Typography, Stack } from "@mui/material";
import SelectPlan from "../../../components/Purchase/ChoosePlan/SelectPlan/SelectPlan";
import ProfPlanUsers from "./ProfPlanUsers/ProfPlanUsers";
import CardPlan from "./CardPlan/CardPlan";
import Spinner from "../../UI/Spinner";
import SystemContext from "../../../context/SystemContext";

const ChoosePlan = ({ Products, groupedData, PlanChosenId, updateTagUser }) => {
  const { t } = useTranslation();
  const payload = useSelector((state) => state.purchase);
  const [flowContent, setFlowContent] = useState(null);
  const { changePropertyUrl } = useContext(SystemContext);

  const FlowPlan = {
    SelectPlan: {
      title: t("purchase.fin_the_best_plan_for_you"),
      url: "/comprar/plano",
      desc: t(
        "purchase.answer_a_few_quick_questions_so_we_can_find_the_best_plan_for_you"
      ),
      component: <SelectPlan />,
    },
    ProfPlanUsers: {
      title: t("purchase.fin_the_best_plan_for_you"),
      url: "/comprar/plano/profissional",
      desc: t(
        "purchase.answer_a_few_quick_questions_so_we_can_find_the_best_plan_for_you"
      ),
      component: <ProfPlanUsers />,
    },
    ProfPlanTen: {
      title: t("purchase.the_professional_plan"),
      url: "/comprar/plano/profissional/10",
      desc: t("purchase.we_recommend_professional_for_you"),
      component: (
        <CardPlan
          updateTagUser={updateTagUser}
          changePropertyUrl={changePropertyUrl}
          PlanName={t("purchase.professional_plan_ten_users")}
          PlanValueMonthly={
            groupedData &&
            groupedData[
              payload.PostData?.product_id[0]
            ]?.prices?.monthly?.toLocaleString("pt-br", {
              style: "currency",
              currency: "BRL",
            })
          }
          PlanValueAnnual={
            groupedData &&
            groupedData[
              payload.PostData?.product_id[0]
            ]?.prices?.annual?.toLocaleString("pt-br", {
              style: "currency",
              currency: "BRL",
            })
          }
          PlanItems={[
            t("purchase.access_to_all_games_in_pt_br"),
            t("purchase.unlimited_plays"),
            t("purchase.access_to_achievements"),
            t("purchase.access_to_goals"),
            t("purchase.access_to_audios"),
            t("purchase.general_and_game_statistics"),
            t("purchase.add_up_to_ten_users"),
          ]}
        />
      ),
    },
    ProfPlanThirty: {
      title: t("purchase.the_professional_plan"),
      url: "/comprar/plano/profissional/30",
      desc: t("purchase.we_recommend_professional_for_you"),
      component: (
        <CardPlan
          updateTagUser={updateTagUser}
          PlanName={t("purchase.professional_plan_thirty_users")}
          changePropertyUrl={changePropertyUrl}
          PlanValueMonthly={
            groupedData &&
            groupedData[PlanChosenId]?.prices?.monthly?.toLocaleString("pt-br", {
              style: "currency",
              currency: "BRL",
            })
          }
          PlanValueAnnual={
            groupedData &&
            groupedData[PlanChosenId]?.prices?.annual?.toLocaleString("pt-br", {
              style: "currency",
              currency: "BRL",
            })
          }
          PlanItems={[
            t("purchase.access_to_all_games_in_pt_br"),
            t("purchase.unlimited_plays"),
            t("purchase.access_to_achievements"),
            t("purchase.access_to_goals"),
            t("purchase.access_to_audios"),
            t("purchase.general_and_game_statistics"),
            t("purchase.add_up_to_thirty_users"),
          ]}
        />
      ),
    },
    FamilyPlan: {
      title: t("purchase.the_family_plan"),
      url: "/comprar/plano/familia",
      desc: t("purchase.we_recommend_family_for_you"),
      component: (
        <CardPlan
          updateTagUser={updateTagUser}
          PlanName={t("purchase.family_plan")}
          changePropertyUrl={changePropertyUrl}
          PlanValueMonthly={
            groupedData &&
            groupedData[PlanChosenId]?.prices?.monthly?.toLocaleString("pt-br", {
              style: "currency",
              currency: "BRL",
            })
          }
          PlanValueAnnual={
            groupedData &&
            groupedData[PlanChosenId]?.prices?.annual?.toLocaleString("pt-br", {
              style: "currency",
              currency: "BRL",
            })
          }
          PlanItems={[
            t("purchase.access_to_all_games_in_pt_br"),
            t("purchase.unlimited_plays"),
            t("purchase.access_to_achievements"),
            t("purchase.access_to_goals"),
            t("purchase.access_to_audios"),
            t("purchase.general_and_game_statistics"),
            t("purchase.add_up_to_five_users"),
          ]}
        />
      ),
    },
    IndividualPlan: {
      title: t("purchase.the_individual_plan"),
      url: "/comprar/plano/individual",
      desc: t("purchase.we_recommend_individual_for_you"),
      component: (
        <CardPlan
          updateTagUser={updateTagUser}
          changePropertyUrl={changePropertyUrl}
          PlanName={t("purchase.individual_plan")}
          PlanValueMonthly={
            groupedData &&
            groupedData[PlanChosenId]?.prices?.monthly?.toLocaleString("pt-br", {
              style: "currency",
              currency: "BRL",
            })
          }
          PlanValueAnnual={
            groupedData &&
            groupedData[PlanChosenId]?.prices?.annual?.toLocaleString("pt-br", {
              style: "currency",
              currency: "BRL",
            })
          }
          PlanItems={[
            t("purchase.access_to_all_games_in_pt_br"),
            t("purchase.unlimited_plays"),
            t("purchase.access_to_achievements"),
            t("purchase.access_to_goals"),
            t("purchase.access_to_audios"),
            t("purchase.general_and_game_statistics"),
          ]}
        />
      ),
    },
    OpenSpinner: {
      component: <Spinner />,
      title: "",
      desc: ""
    },
  };

  useEffect(() => {
    if (payload && payload.purchase && payload.purchase.step && payload.purchase.content === "ChoosePlan") {
      changePropertyUrl(FlowPlan[payload.purchase.step].url)
      if (payload.purchase.step in FlowPlan)
        setFlowContent(FlowPlan[payload.purchase.step]);
      else
        console.log("not have tratative payload.purchase.step", payload.purchase.step)
    }
  }, [payload, groupedData, PlanChosenId]);

  return (flowContent ? (
    <Stack
      spacing={3}
      sx={{
        padding: { xs: 2, sm: 3, md: 4 },
        direction: 'column',
        alignItems: 'center',
        width: '100%',
        maxWidth: { xs: '100%', sm: '600px', md: '800px' },
        margin: '0 auto'
      }}
    >
      <Typography
        variant="h4"
        component="h1"
        sx={{
          fontWeight: 'bold',
          textAlign: 'center',
          color: '#662D91',
          fontSize: { xs: '1.5rem', sm: '2rem', md: '2.125rem' }
        }}
      >
        {flowContent.title}
      </Typography>
      <Typography
        variant="body1"
        sx={{
          textAlign: 'center',
          color: 'text.secondary',
          fontSize: { xs: '0.875rem', sm: '1rem' },
          maxWidth: { xs: '100%', sm: '500px', md: '600px' }
        }}
      >
        {flowContent.desc}
      </Typography>
      {Products ? (
        <Box sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          alignItems: 'center'
        }}>
          {flowContent.component}
        </Box>
      ) : (
        <Spinner />
      )}
    </Stack>
  ) : null)
};

export default ChoosePlan;